import jwt_decode from 'jwt-decode';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { StoreService } from './store.service';
import { UtilizadorModel } from '../models';
import { map } from 'rxjs/operators';
import { Helpers } from '@core/helpers/helpers';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  context = '/utilizadores';
  constructor(
    private apiService: ApiService,
    private storeService: StoreService,
    private helper: Helpers
  ) {}

  login(credentials): Observable<UtilizadorModel> {
    return this.apiService.post(`/login`, credentials).pipe(
      map((data) => {
        this.storeService.storeSession(data);
        this.helper.setToken(data);
        return data;
      })
    );
  }

  logout() {
    this.storeService.destroySession();
    this.helper.logout()
  }

  register(utilizador: UtilizadorModel): Observable<UtilizadorModel> {
    return this.apiService.post(`${this.context}`, utilizador);
  }

  getCurrentUser() {
    const storedUser = this.storeService.getSessionAttr('utilizador');
    return JSON.parse(storedUser);
  }

  getAll(): Observable<UtilizadorModel[]> {
    return this.apiService.get(`${this.context}`);
  }

  getById(id: number): Observable<UtilizadorModel> {
    return this.apiService.get(`${this.context}/${id}`);
  }

  update(utilizador: UtilizadorModel): Observable<UtilizadorModel> {
    const { id } = utilizador;
    return this.apiService.put(`${this.context}/${id}`, utilizador);
  }

  updatePassword(senhas: any) {
    const { id } = senhas;
    return this.apiService.put(`${this.context}/${id}/senha`, senhas);
  }

  delete(id: number) {
    return this.apiService.delete(`${this.context}/${id}`).pipe(
      map((data) => {
        const storedUser = this.storeService.getSessionAttr('utilizador');
        const user = JSON.parse(storedUser);

        if (id == user.id) {
          this.logout();
        }
        return data;
      })
    );
  }
}
